import { useAuthStore } from "../../lib/auth/authStore";

function truncate(email: string): string {
	if (email.length <= 24) return email;
	return `${email.slice(0, 21)}…`;
}

/**
 * Signed-in account pill: the user's email + a role badge, with a logout
 * action. Renders nothing when no one is signed in (so it can live
 * unconditionally in the layout). Logout just clears the session JWT.
 */
export function AccountChip() {
	const user = useAuthStore((s) => s.user);
	const token = useAuthStore((s) => s.token);
	const logout = useAuthStore((s) => s.logout);

	if (!token || !user) return null;

	return (
		<div className="flex items-center gap-2 rounded-full border border-slate-800 bg-slate-900/60 py-1 pr-1 pl-3 text-xs">
			<span className="h-2 w-2 rounded-full bg-emerald-400" />
			<span className="text-slate-300" title={user.email}>
				{truncate(user.email)}
			</span>
			<span className="rounded-full bg-slate-800 px-2 py-0.5 font-medium text-slate-300 capitalize">
				{user.role}
			</span>
			<button
				type="button"
				onClick={logout}
				className="rounded-full px-2 py-0.5 text-slate-400 transition hover:bg-slate-800 hover:text-slate-200"
			>
				Logout
			</button>
		</div>
	);
}
